import axios from 'axios';

const promiseCache: Record<string, Promise<unknown> | undefined> = {};

export function getMemoizedData<T = unknown>(url: string): Promise<T> {
    if (promiseCache[url]) {
        return promiseCache[url] as Promise<T>;
    }

    promiseCache[url] = axios.get<T>(url)
        .then(response => response.data)
        .catch(error => {
            delete promiseCache[url];
            throw error;
        });

    return promiseCache[url] as Promise<T>;
}

export function clearDataCache(url: string | null = null): void {
    if (url) {
        delete promiseCache[url];
    } else {
        for (const key in promiseCache) {
            delete promiseCache[key];
        }
    }
}
